import { NotificationService } from '../../../shared/notification/notification.service';
import { ProfileRead } from '../../shared/profile-read.model';
import { MemberActivityTypeModel } from '../../../member/shared/member-activity-type.model';
import { MemberService } from '../../../member/shared/member.service';
import { BenefitService } from '../../../benefits/shared/benefit.service';
import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MembershipLevelDto } from 'src/app/benefits/shared/dto/membership-level.dto';
import { NewMemberService } from 'src/app/new-member/shared/new-member.service';
import { NewMemberSimpleDto } from 'src/app/new-member/dto/new-member.dto';
import { TranslationService } from 'src/app/shared';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'wl-profile-add-as-member',
  templateUrl: './profile-add-as-member.component.html',
  styleUrls: ['./profile-add-as-member.component.less'],
  //providers: [BenefitService],
    standalone: false
})
export class ProfileAddAsMemberComponent implements OnInit {
  @Input() show: boolean;
  @Input() profile: ProfileRead;
  @Input() embedMode = false;
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  public memberActivityTypes: SelectItem[] = [];
  public membershipLevels: MembershipLevelDto[];
  public isMember = true;
  public selectedActivityType = {} as MemberActivityTypeModel;
  public selectedActivityDate: Date = new Date();
  public selectedMembershipLevel: MembershipLevelDto;

  public isSaving = false;

  constructor(
    private _membershipLevelService: BenefitService,
    private _membershipService: MemberService,
    private _newMemberService: NewMemberService,
    private _observationService: ObservationService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService
  ) {}

  get canSave() {
    return Boolean(this.selectedActivityType.ActivityTypeID) && this.isMember;
  }

  ngOnInit() {
    this._membershipLevelService.getMembershipLevels().then((result) => {
      this.membershipLevels = result.Result;
    });
    this._membershipService.getMemberActivityTypes().then((result) => {
      result.sort((x, y) => {
        if (x.ActivityType < y.ActivityType) {
          return -1;
        } else if (x.ActivityType > y.ActivityType) {
          return 1;
        } else {
          return 0;
        }
      });

      this.memberActivityTypes = result.map<SelectItem>((x) => {
        return { label: x.ActivityType, value: x.ActivityTypeID };
      });
    });
  }

  dateSelected(date) {
    this.selectedActivityDate = date;
  }

  save() {
    this.isSaving = true;
    const selectedMembershipLevelId = this.selectedMembershipLevel ? this.selectedMembershipLevel.MembershipLevelId : null;
    return this._newMemberService
      .updateProfileAsNewMember(this.profile.ProfileId, {
        ActivityTypeId: this.selectedActivityType?.ActivityTypeID,
        MemberActivityDate: this.selectedActivityDate,
        MembershipLevelId: selectedMembershipLevelId,
      } as NewMemberSimpleDto)
      .then(
        () => {
          this.isSaving = false;
          this._observationService.profileUpdated(this.profile.ProfileId);
          this.saved.emit();
          this.close.emit();
          this._notificationService.success(this._translationService.getInstant('profiles.view.add-member.success'));
        },
        () => (this.isSaving = false)
      );
  }

  saveAndContinueEditing() {
    this.save().then(() => {
      this._navigationService.navigateToProfileEdit(this.profile.ProfileId);
    });
  }
}
